/**
 * @file: 隔板 render 方法
 * @author: xiaolong.huang@dmall.com
 */

import * as Toolkit from '../../../toolkit/index';
import * as UIToolkit from '../../../UIToolkit/index';
import * as FrontCubeData from '../../../frontCubeData/index';

export function bafflePlate(cube: CubeNode): void {
    let $el: JQuery<HTMLElement> = cube.jView;
    let $baffleplate: JQuery<HTMLElement> = craeteBaffleplate();
    let style: FreeObjMap = createStyle(cube);

    initDom(cube);
    $el.addClass('is-baffleplate')
        .append($baffleplate)
        .css(style);
}

function initDom(cube: CubeNode): void {
    cube.jView.addClass('is-baffleplate');
    cube.jView.children().each(function(index: number, item: HTMLElement) {
        let $item: JQuery<HTMLElement> = $(item);

        if (!$item.hasClass('flow-border-left')
            && !$item.hasClass('flow-border-right')
            && !$item.hasClass('flow-border-top')
            && !$item.hasClass('flow-border-bottom')
            && !$item.hasClass('selected-mask')
            && !$item.hasClass('shelvesbuild-e-g-default__in-layer')) {
            $item.remove();
        }
    });
}

function craeteBaffleplate(): JQuery<HTMLElement> {
    return $(document.createElement('div')).addClass('shelvesbuild-e-g-default__baffleplate');
}

function createStyle(cube: CubeNode): FreeObjMap {
    let result: FreeObjMap = {
        position: 'absolute',
        left: UIToolkit.getPXSizeValue(cube.id, 'posX'),
        bottom: UIToolkit.getPXSizeValue(cube.id, 'posY'),
        width: UIToolkit.getPXSizeValue(cube.id, 'width'),
        height: UIToolkit.getPXSizeValue(cube.id, 'height')
    };

    return result;
}
